import { useQuery } from '@tanstack/react-query';
import Globals from '../Globals.json';
import api from '../Services/api';
import {
  CopyKind,
  CopySource,
} from '../Components/Cadastro/CopyComplements/copyComplements';

interface UseComplementSourcesOptions {
  kind: CopyKind;
  storeId?: number;
  enabled?: boolean;
}

const endpoints: Record<CopyKind, string> = {
  complements: Globals.api.complementSources,
  associateds: Globals.api.associatedSources,
};

// Categorias e produtos com itens próprios (os que só herdaram da categoria vêm de fora)
export const useComplementSources = ({
  kind,
  storeId,
  enabled = true,
}: UseComplementSourcesOptions) => {
  return useQuery<CopySource[]>({
    queryKey: ['copy-sources', kind, storeId],
    queryFn: async () => {
      const response = await api.get(`${endpoints[kind]}?store_id=${storeId}`);
      return response.data?.data ?? [];
    },
    enabled: enabled && !!storeId,
    staleTime: 0, // recarrega a cada abertura do modal: os itens mudam ao salvar produtos/categorias
    refetchInterval: false,
  });
};
